import { type ConversationalMMRunMetrics } from '@fruitful/types';

import type { QAThreadScorers } from '../utils/qaThreadScorers';

export type QARunStatus = 'pending' | 'running' | 'done' | 'error';

export interface QALogEntry {
    id: number;
    source: 'agent' | 'persona' | 'widget';
    label: string;
    content: string;
}

export interface QARunState {
    status: QARunStatus;
    metrics: ConversationalMMRunMetrics | null;
    scorers: QAThreadScorers | null;
    threadId: string | null;
    promptName: string | null;
    widgetInteractions: number;
    error: string | null;
    log: QALogEntry[];
}

export const emptyQARun = (): QARunState => ({
    status: 'pending',
    metrics: null,
    scorers: null,
    threadId: null,
    promptName: null,
    widgetInteractions: 0,
    error: null,
    log: [],
});
